import React from "react";

import { defaultTranslations } from "../constants/defaultTranslations";

export const TranslationsContext = React.createContext(defaultTranslations);

export function TranslationsProvider({ children, overrides }) {
  const mergedContext = { ...defaultTranslations, ...(overrides || {}) };
  return (
    <TranslationsContext.Provider value={mergedContext}>
      {children}
    </TranslationsContext.Provider>
  );
}